import { fromJSON as dropdownFromJSON } from "common/components/Dropdown/Dropdown";
import { getPrettyName } from "common/helpers/Pretty";
import { AssociationType, Nullable } from "common/types";
import { List, Record } from "immutable";
import { DateStringNumber } from "common/records";
import { checkDate } from "common/helpers/Date";

export const patternFromJSON = (json: Partial<IPatternData>): PatternRecord => {
  const recordData: IPatternRecord = { ...(json as any) };

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new PatternRecord(recordData);
};

export type PatternDocType =
  | "estimate"
  | "cover_page"
  | "job_photos"
  | "product_images"
  | "cost"
  | "inspection"
  | "presentation_template"
  | "commission"
  | "labor_summary"
  | "presentation"
  | "slide_template"
  | "inspection_pdf"
  | "cf_job_resulting";

export const patternDocTypes = List<PatternDocType>([
  "estimate",
  "cover_page",
  "job_photos",
  "product_images",
  "cost",
  "inspection",
  "presentation_template",
  "commission",
  "labor_summary",
  "presentation",
  "slide_template",
  "inspection_pdf",
  "cf_job_resulting",
]);

export const patternDocTypesDropdown = patternDocTypes.map((docType) =>
  dropdownFromJSON({
    id: docType,
    name: getPrettyName(docType),
  }),
);

export interface IPatternData {
  id: number;
  name: string;
  doc_type: Nullable<PatternDocType>;
  view: string;
  compiled_view: string;
  active: boolean;
  patternable_id: Nullable<number>;
  patternable_type: Nullable<AssociationType>;
  parent_id: Nullable<number>;
  editable: boolean;
  updated_at: DateStringNumber;
  created_at: DateStringNumber;
}

export interface IPatternRecord {
  id: number;
  name: string;
  doc_type: Nullable<PatternDocType>;
  view: string;
  compiled_view: string;
  active: boolean;
  patternable_id: number;
  patternable_type: Nullable<AssociationType>;
  parent_id: number;
  editable: boolean;
  updated_at: Date;
  created_at: Date;
}

export const defaultPatternProps: IPatternRecord = {
  id: 0,
  name: "",
  doc_type: null,
  view: "",
  compiled_view: "",
  active: true,
  patternable_id: 0,
  patternable_type: null,
  parent_id: 0,
  editable: false,
  created_at: new Date(),
  updated_at: new Date(),
};

export class PatternRecord extends Record(defaultPatternProps) implements IPatternRecord {}
